import { assertNever } from '@kofno/piper';
import { action, computed, makeObservable, observable } from 'mobx';
import GroupsStore from '..';
import { error } from '../../ErrorHandling';
import { TPlainTextKey } from '../../Translations';
import { GroupsOptionsResource, State, ready, waiting } from './Types';

class GroupsOptionsStore {
  @observable _state: State = waiting();

  readonly groupsStore: GroupsStore;

  constructor(groupsStore: GroupsStore) {
    makeObservable(this);
    this.groupsStore = groupsStore;
  }

  @action
  ready = (resource: GroupsOptionsResource) => {
    this._state = ready(resource);
  };

  @action
  error = (msg: TPlainTextKey) => {
    this._state = error(msg);
  };

  @computed
  get state(): State {
    switch (this._state.kind) {
      case 'waiting':
        return this.groupsStore.optionsState;
      case 'ready':
      case 'error':
      case 'loading':
        return this._state;
      default:
        return assertNever(this._state);
    }
  }
}

export default GroupsOptionsStore;
